/** Default-deny: only these templates are ever reported in http events. AppIds (11-char base62) are
 *  indistinguishable from slugs, and paths like /api/invite/{code} carry secrets — anything not
 *  listed is reported as 'other' with no path at all. */
const TEMPLATES: [string, RegExp, string][] = [
  ['POST', /^api\/auth\/login$/, 'POST /api/auth/login'],
  ['GET', /^api\/auth\/refresh/, 'GET /api/auth/refresh'],
  ['GET', /^api\/company\/[^/]+$/, 'GET /api/company/{id}'],
  ['PUT', /^api\/company\/[^/]+$/, 'PUT /api/company/{id}'],
  ['GET', /^api\/company$/, 'GET /api/company'],
  ['POST', /^api\/company$/, 'POST /api/company'],
  ['GET', /^api\/site\/[^/]+$/, 'GET /api/site/{id}'],
  ['PUT', /^api\/site\/[^/]+$/, 'PUT /api/site/{id}'],
  ['GET', /^api\/chain\/[^/]+$/, 'GET /api/chain/{id}'],
  ['POST', /^api\/chain\/[^/]+\/invite$/, 'POST /api/chain/{id}/invite'],
  ['GET', /^api\/chain\/[^/]+\/invite$/, 'GET /api/chain/{id}/invite'],
  ['POST', /^api\/document$/, 'POST /api/document'],
  ['GET', /^api\/document\/[^/]+$/, 'GET /api/document/{id}'],
  ['GET', /^api\/document-type$/, 'GET /api/document-type'],
  ['POST', /^api\/traces\/[^/]+\/submit/, 'POST /api/traces/{id}/submit'],
  ['GET', /^api\/user\/language$/, 'GET /api/user/language'],
];

export function matchHttpTemplate(method: string, url: string): string {
  const path = url.split(/[?#]/)[0].replace(/^\//, '');
  const hit = TEMPLATES.find(([m, re]) => m === method && re.test(path));
  return hit ? hit[2] : 'other';
}

export function durationBucket(ms: number): string {
  return ms < 300 ? '<300ms' : ms < 1000 ? '<1s' : ms < 5000 ? '<5s' : '>=5s';
}
